import { User } from '../entities/user.entity';

const EMPTY_USER: User = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
  accountId: '',
  isEnabled: true,
  createdAt: '',
  updatedAt: '',
};

export function mapUser(raw: any, fallbackAccountId?: string): User {
  if (!raw || typeof raw !== 'object') {
    return { ...EMPTY_USER };
  }
  return {
    id: raw.id || '',
    firstName: raw.first_name || '',
    lastName: raw.last_name || '',
    email: raw.email || '',
    phone: raw.phone || '',
    media: raw.media_data || null,
    dateOfBirth: raw.date_of_birth,
    isVip: raw.is_vip,
    vipLevel: raw.vip_level,
    role: raw.role || '',
    accountId: raw.account_id || fallbackAccountId || '',
    isEnabled:
      raw.is_enabled !== undefined
        ? raw.is_enabled
        : raw.disabled !== undefined
          ? !raw.disabled
          : true,
    facebookId: raw.facebook_id,
    instagramId: raw.instagram_id,
    tiktokId: raw.tiktok_id,
    whatsappId: raw.whatsapp_id,
    defaultAddressId: raw.default_address_id,
    isDeveloper: raw.is_developer || false,
    companyName: raw.company_name,
    isAutoCreated: raw.is_auto_created,
    createdAt: raw.created_at || '',
    updatedAt: raw.updated_at || '',
  };
}
